const Batch = {
  queryList: [
    {
      name: 'year',
      label: '学位类型',
      notNull: true,
      component: 'select',
      componentAttr: {
        options: []
      }
    }
  ],
  urlMap: {
    select: '/custom/customPermission/customList',
    update: '/school/schoolDegreeOffice/saveOrUpdate',
    delete: '/school/schoolDegreeOffice/delete/{id}'
  },
  operList: [// 操作列表
    // {
    //   name: 'add',
    //   label: '新增',
    //   show: true,
    //   action: {
    //     type: 'dialog',
    //     addr: 'systemManage/employerEdit'
    //   }
    // }
  ],
  titles: [
    {
      name: 'auditYear',
      label: '评阅规则名称'
    },
    {
      name: 'seasonName',
      label: '创建时间'
    },
    {
      name: 'operation',
      label: '操作',
      actionList: [
        {
          label: '编辑',
          name: 'edit',
          width: 800,
          kind: 'primary', // error
          type: 'dialog', // request, router, dialog, func
          addr: 'systemManage/patchUnit?{userId}'
        },
        {
          label: '删除',
          kind: 'primary',
          type: 'request',
          addr: 'delete',
          data: ['{id}'],
          confirm: {
            desc: '确认删除？'
          }
        },
        {
          label: '设置为默认评阅规则',
          kind: 'primary',
          type: 'request',
          addr: 'delete',
          data: ['{id}'],
          confirm: {
            desc: '确认设置为默认评阅规则？'
          }
        }
      ]
    }
  ]
}
export default Batch



// WEBPACK FOOTER //
// ./src/layout/regularPage/config/configManage/fuExportFieldConfig.js